<template>
    <div class="brand-book-colors-hero">
        <BrandBookSectionHeroImage src="CORES-2_01.png" />
        <BrandBookSectionHeroImage src="CORES-2_02.png" />
        <BrandBookSectionHeroImage src="CORES-2_03.png" />
    </div>
</template>

<script>
    import BrandBookSectionHeroImage from './BrandBookSectionHeroImage';

    export default {
        name: 'BrandBookColorsHero',
        components: { BrandBookSectionHeroImage },
    };
</script>
